// extracted by mini-css-extract-plugin
export var payCycle = "Price-module--payCycle--dc973";
export var price = "Price-module--price--99bfb";
export var wrapper = "Price-module--wrapper--8578f";